import { render, staticRenderFns } from "./ProductSizes.vue?vue&type=template&id=6f26061e&scoped=true&"
import script from "./ProductSizes.vue?vue&type=script&lang=js&"
export * from "./ProductSizes.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizes.vue?vue&type=style&index=0&id=6f26061e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f26061e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VSwitch,VTextField})
